import { render, staticRenderFns } from "./Piao6.vue?vue&type=template&id=24293739&"
import script from "./Piao6.vue?vue&type=script&lang=js&"
export * from "./Piao6.vue?vue&type=script&lang=js&"
import style0 from "./Piao6.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports